<template>
    <ULandingCard
        :to="props.to"
        :title="props.title"
        :description="props.description"
        :icon="props.icon"
        :iconColor="props.iconColor"
        :color="props.color"
        :orientation="props.image ? 'horizontal' : 'vertical'"
        :ui="{
            icon: {
                base: `w-8 h-8 flex-shrink-0 text-${props.iconColor}-600
        dark:text-white`
            },
            title: `text-${props.color}-600 text-base font-bold truncate dark:text-white`
        }">
        <template v-if="props.image">
            <NuxtImg format="webp" width="640" height="360" class="w-[100%] rounded-lg" :src="props.src" :alt="alt" />
        </template>
    </ULandingCard>
</template>

<script setup>
    const config = useRuntimeConfig()

    const props = defineProps({
        to: {
            type: String,
            default: '/',
            required: false
        },
        title: {
            type: String,
            default: '',
            required: false
        },
        description: {
            type: String,
            default: '',
            required: false
        },
        icon: {
            type: String,
            default: '',
            required: false
        },
        iconColor: {
            type: String,
            default: 'green',
            required: false
        },
        color: {
            type: String,
            default: 'green',
            required: false
        },
        image: {
            type: Boolean,
            default: false,
            required: false
        },
        src: {
            type: String,
            default: '',
            required: false
        }
    })

    const alt = computed(() => {
        return `${config.public.company.name}`
    })
</script>
